import client from "../../../api/client";
import mapLoginPayload from "../utils/mapLoginPayload";

export default async function requestLoginOtp(email) {
  const payload = mapLoginPayload(email);
  const response = await client.post("/auth/login", payload);
  return response.data;
}